import type { ThemeOptions } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles/createPalette' {
    interface Palette {
        border: Palette['primary'];
    }
    interface PaletteOptions {
        border: PaletteOptions['primary'];
    }
}

export default function createCustomTheme(options: ThemeOptions) {
    return createTheme(options);
}
